var map = {
	"./1942-chinese-canadian-recruits-victoria.jpg": "5cc0",
	"./A01-20040015-001.jpg": "b1a9",
	"./A02-20070073-001.jpg": "e76f",
	"./A03-20190232-001_b.jpg": "38e5",
	"./A04-20170753-001.jpg": "318b",
	"./A05-20060217-001.jpg": "c8be",
	"./A06-19980071-005.jpg": "793a",
	"./A07-20070158-003-LR.jpg": "3dfc",
	"./A07-20070158-005.jpg": "c616",
	"./A08-20160664-001.jpg": "9f51",
	"./A09-19720228-001.jpg": "f40c",
	"./A10-20000044-011.jpg": "f8ce",
	"./A11a_20120205-001.jpg": "0831",
	"./A12a_19950037-010.jpg": "3245",
	"./A12b_19950037-009.jpg": "615e",
	"./A13a_20030051-007008.jpg": "9fec",
	"./A13b_20030051-007.1 and -008.1_verso.jpg": "da02",
	"./A13c_2.G.1.3-GR7a.jpg": "b280",
	"./A13d_2.G.1.3-GR7b.jpg": "ac90",
	"./A14_19410001-003.jpg": "1ddd",
	"./A15_20170206-001.jpg": "0208",
	"./A16_19920197-001.jpg": "d7c8",
	"./A17a_20180249-006.jpg": "2e5f",
	"./A17b_20180249-007_1.jpg": "1bdb",
	"./A18a_19960036-001_ongrey.jpg": "3f7b",
	"./A18b_FRENCH_REF PAM NA 9330-08 C2 R4 1992_FRENCH.jpg": "4fd6",
	"./A18b_REF PAM NA 9330-08 C2 R4 1992.jpg": "b95b",
	"./A19_20120114-001.jpg": "db1a",
	"./A20_20110171-001.jpg": "0f57",
	"./A20b_Robert Norton WWII.jpg": "99f3",
	"./Art01-19710261-0656.jpg": "2e2f",
	"./Art02-19710261-0056.jpg": "7843",
	"./Art03-20130078-001.jpg": "876e",
	"./Art04-19710261-2042.jpg": "e74b",
	"./Art05-19970043-001.jpg": "44f7",
	"./Art06-19970052-001.jpg": "40ab",
	"./Art07-20110073-003.jpg": "667a",
	"./Art08-20110076-001-1280x906.jpg": "a0ee",
	"./Art08-20110076-001.jpg": "c4fc",
	"./Art09-19670070-014.jpg": "3a26",
	"./Art10-20180556-001.jpg": "9481",
	"./Art11_20200359-001.jpg": "5a93",
	"./Art12_il2008006-001_lower.jpg": "dcab",
	"./Art13_20170667-001.jpg": "a930",
	"./CWM-WebsiteTiles-EOTAS-F01-CartridgeCase-72dpi.jpg": "b33c",
	"./CWM-WebsiteTiles-EOTAS-F01-Certificate-72dpi.jpg": "8cb0",
	"./CWM-WebsiteTiles-EOTAS-F01-IzzyDoll-72dpi.jpg": "f332",
	"./CWM-WebsiteTiles-EOTAS-F01-Letter-72dpi.jpg": "17ff",
	"./CWM-WebsiteTiles-EOTAS-F01-Photograph-72dpi.jpg": "5521",
	"./CWM-WebsiteTiles-EOTAS-F01-Purse-72dpi.jpg": "b029",
	"./CWM-WebsiteTiles-EOTAS-F01-ServiceFlag-72dpi.jpg": "054a",
	"./CWM-WebsiteTiles-EOTAS-F01-Teddy-72dpi.jpg": "97c9",
	"./CWM-WebsiteTiles-EOTAS-F01-UnknownSoldier-72dpi.jpg": "77fe",
	"./Doc01-20040015-007.jpg": "81a5",
	"./Doc02-20060194-002_1.jpg": "2e1c",
	"./Doc03-20050108-003.jpg": "cc59",
	"./Doc04-20030359-028_28_p1.jpg": "a9cf",
	"./Doc05-20130617-001_16_June_2000.jpg": "927a",
	"./Doc06-20160257-003_Site-No6_Illustration.jpg": "cb4a",
	"./Doc07-20100094-003_cover.jpg": "3360",
	"./Doc07_20100094-003_1.jpg": "cac4",
	"./Doc08-20060136-001.jpg": "5a77",
	"./Doc09-20060073-001.jpg": "b4b0",
	"./Doc10-19990092-068_eng.jpg": "2945",
	"./Doc11a_20160159-001_p3.jpg": "361f",
	"./Doc12a_20110057-009.jpg": "4582",
	"./Doc12b_20110057-020_21d_Minnie Gray.jpg": "1c4d",
	"./Doc13_WindsorStar18June45p3_JosephHong.jpg": "1d36",
	"./Doc14a_20030023-062_6-Jan-1980.jpg": "e3ff",
	"./Doc14b_20030023-062_13 Sept 1979_1.jpg": "8100",
	"./Doc14b_20030023-062_13 Sept 1979_2.jpg": "630a",
	"./Doc14c_20030023-256_24.jpg": "2517",
	"./Doc15a_19830409-005_front.jpg": "e78b",
	"./Doc15b_19830409-005_back.jpg": "629e",
	"./Doc16a.2_20070019-001_18 Aug 1915_2.jpg": "68fd",
	"./Doc16a1_20070019-001_18-Aug-1915_1.jpg": "e39c",
	"./Doc16b_20070019-036.jpg": "0ed2",
	"./Doc17a_Poppy-Campaign-ad.jpg": "c9c4",
	"./Doc17b_Lillian_Freiman_at_desk.jpg": "acaf",
	"./Doc18a_Maximilian-Lee.jpg": "67a8",
	"./Doc18b_Shaelyn Lorensen.jpg": "1351",
	"./Doc18c_Anna Mikhailov.jpg": "0b52",
	"./Doc19_Ott-Citizen-12-Nov-1941-p-22_Armistice-of-1918.jpg": "cf58",
	"./Med01.03-1-AileenMayHoward.jpg": "a587",
	"./Med02.06-2-20190232-014_3.jpg": "63dc",
	"./Med03.04-1-20060212-002_tag.jpg": "8667",
	"./Med04.03-1-VAC.jpg": "72f3",
	"./Med05.05-3-CWM2018-0037-0050-Dm.jpg": "ae41",
	"./Med06_GR01-20070073-001.jpg": "a87f",
	"./Ov01-19930013-464.jpg": "1622",
	"./Ov02-PA-113659.jpg": "3f24",
	"./Ov03-19910238-130.jpg": "2ba6",
	"./Ov04-AR2006-P005-0031.jpg": "b657",
	"./Ov05-19800618-014.jpg": "6927",
	"./P01-il2015015-005.jpg": "cea7",
	"./P02-19930003-453.jpg": "5683",
	"./P03-PA-129070.jpg": "4363",
	"./P04-20180400-002_1.jpg": "1fc3",
	"./P05-20140588-002-3.jpg": "79fc",
	"./P06-IS2013-2002-058.jpg": "15fc",
	"./P07-AR2008-Z103-19.jpg": "817b",
	"./P08-IS2007-1018.jpg": "5776",
	"./P09-19830626-001_3.jpg": "cd0d",
	"./P10_IS13-2018-0004-010.jpg": "d011",
	"./P11a_39824078.jpg": "a487",
	"./P11b_Ainsworth Dyer.jpg": "11d1",
	"./P12_2001-11-054-Funeral.jpg": "de9a",
	"./P13_sandeep-brar.jpg": "0f7b",
	"./P14_Mitsui_2014-10-1-7.jpg": "06da",
	"./P14b_Matsumi attestation papers_B6268-S049.jpg": "7433",
	"./P15a_130516_Cup_Arrival.jpg": "2268",
	"./P15b_19920085-1415.jpg": "6b5a",
	"./P16_19800746-010.jpg": "9391",
	"./P17a_Tims-Poppies-7.jpg": "5f52",
	"./P17b_Tim's Poppies-2.jpg": "cdee",
	"./P18_20000224-028_7.jpg": "eb1b",
	"./arnold-moses-front-right-wesley-burnham-front-left-107th-battalion-cef.jpg": "1a6b",
	"./cwm-websitetiles-itcwt-f01-museum-72dpi.jpg": "7306",
	"./cwm-websitetiles-itwct-f01-memorialhall-72dpi.jpg": "6030",
	"./cwm-websitetiles-itwct-f01-moriyama-72dpi.jpg": "4795",
	"./cwm2018-0037-0058-dm.jpg": "735c",
	"./ov10_lac-pa-22980_cropped.jpg": "5080",
	"./ov5_cwn2011-0065-0006-dp1.jpg": "089b",
	"./ov7_e010777310-v8_1.jpg": "c4d6"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c084";